import { Modal } from "react-bootstrap";
import queryString from "query-string";
import { useQuery } from "react-query";
import moment from "moment";
import { format } from "date-fns";
import { useAuth } from "../../hooks/useAuth";
import ModalLoader from "../utils/ModalLoader";
import CloseIcon from "mdi-react/CloseIcon";
import TableComponent from "../TableComponent";
import { NoSelectedItemIcon } from "../Icons";

const ReturnItemModal = ({ show, onHide, activeItem, storageLocation }) => {
  const { backendUrl } = useAuth();

  const wareshouseLocal = JSON.parse(
    window.localStorage.getItem("warehouseName")
  );

  const fetchSetUpData = async warehouseID => {
    let response = await fetch(
      `${backendUrl}/api/warehouse/return-history/${warehouseID}?&${queryString.stringify(
        {
          barCode: activeItem?.Bar_Code,
          Trans_ID: activeItem?.Trans_ID,
        }
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const { data } = await response.json();

    data.locations = [
      { value: "All", label: "All" },
      ...data.locations.map(el => ({
        value: el.locationID,
        label: el.name,
      })),
    ];
    return data;
  };

  const {
    data = {
      countItemsIssueLog: 0,
      issuedItems: [],
      locations: [],
    },

    isLoading,
  } = useQuery(
    ["WAREHOUSE_RETURN_ITEMS", { wareshouseLocal }],
    () => fetchSetUpData(wareshouseLocal?.whID),
    {
      keepPreviousData: false,
      staleTime: 0,
    }
  );

  const tableStorageHead = () => {
    return (
      <thead>
        <tr>
          <th>Bar Code</th>
          <th>Serial Number</th>
          <th>Item Name</th>
          <th>Qty Returned</th>
          <th className="text-center">Receiving Officer</th>
          <th>Comment</th>
          <th>Contract</th>
          <th className="text-center">Date</th>
          <th className="text-center">Duration in possession</th>
          <th className="text-center">Storage Location</th>
          <th className="text-center">Returning Officer</th>
        </tr>
      </thead>
    );
  };

  const displayStorageTableData = (el, index) => {
    const given = moment(
      format(new Date(el?.Date_Log), "yyyy-MM-dd"),
      "YYYY-MM-DD"
    );
    const current = moment().startOf("day");

    //Difference in number of days
    const duration = moment.duration(given.diff(current)).asDays();
    return (
      <>
        <td>{el?.Bar_Code}</td>
        <td>{el?.Serial_Number}</td>
        <td>{el?.Item_Name}</td>
        <td className="text-center">{el?.QuantityFromReciever}</td>
        <td className="text-nowrap">
          <span className="px-2">{el?.receivingOfficer || el?.UserName}</span>
        </td>
        <td>{el?.Comment}</td>
        <td>
          {el?.jobs_Issuer?.title}{" "}
          {el.contractsPoNumber ? (
            <span className="px-2">- {el.contractsPoNumber}</span>
          ) : null}
        </td>
        <td>
          {`${format(new Date(el?.Date_Log), "yyyy-MM-dd")} ${
            el?.IssueTime?.includes("Z")
              ? format(new Date(el.IssueTime), "HH:mm:ss a")
              : el?.IssueTime
          }`}
        </td>

        <td className="text-center">
          {duration < 0
            ? `${Math.abs(duration)} day(s) ago`
            : duration === 0
            ? `${duration} day`
            : `${duration} day(s) ahead`}
        </td>
        <td className="text-nowrap">
          {
            storageLocation?.find(item => item.value === el.StorageLocation)
              ?.label
          }
        </td>
        <td className="text-nowrap">{el?.returningOfficer}</td>
      </>
    );
  };

  return (
    <Modal
      onHide={onHide}
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div>
          <div>
            <div className="d-flex justify-content-between">
              <h6>Return Item</h6>
              <div role="button" className="text-lg" onClick={onHide}>
                <CloseIcon />
              </div>
            </div>
          </div>
          <div className="my-3">
            {/*  */}
            {data.issuedItems.length > 0 ? (
              <TableComponent
                responsive
                borderless
                striped
                tableHeadsFunction={tableStorageHead}
                mainDataArray={data.issuedItems}
                tableDataRowFunction={displayStorageTableData}
                className="product-table text-nowrap"
              />
            ) : (
              <div className="d-flex justify-content-center">
                <div className="info text-center">
                  <NoSelectedItemIcon />
                  <p className="my-2 fw-bold">No Return Item Available</p>
                </div>
              </div>
            )}

            {/*  */}
          </div>
        </div>
      </Modal.Body>
      <ModalLoader show={isLoading} />
    </Modal>
  );
};

export default ReturnItemModal;
